import React from 'react';
import PropTypes from 'prop-types';
import AnimateHeight from 'react-animate-height';

const PreviewAnimationOverlay = props => (
  <AnimateHeight
    duration={props.progressBarAnimation.stepInterval}
    height={props.progressBarAnimation.started ? 500.0 * (1.0 - (props.progressBarAnimation.step / (props.progressBarAnimation.totalSteps - 1))) : '500'}
    easing="linear"
    style={{
      position: 'absolute',
      width: '100%',
      bottom: 0,
    }}
  >
    <iframe
      className="document-preview"
      scrolling="no"
      style={{
        WebkitFilter: 'blur(8px)',
        height: 500,
        width: '100%',
        position: 'absolute',
        bottom: 0,
      }}
      src={props.src}
    />
  </AnimateHeight>
);

PreviewAnimationOverlay.propTypes = {
  progressBarAnimation: PropTypes.shape({
    started: PropTypes.bool,
    step: PropTypes.number,
    totalSteps: PropTypes.number,
    stepInterval: PropTypes.number, // in milliseconds
  }).isRequired,
  src: PropTypes.string.isRequired,
};

export default PreviewAnimationOverlay;



// WEBPACK FOOTER //
// ./src-react/ExportDocumentPreviewAnimation/PreviewAnimationOverlay/index.jsx